// src/components/BandeauLectureIllisible.jsx — « Je n'ai pas pu lire ta
// configuration… rien n'est perdu, recharge la page. »
//
// ══ POURQUOI (Dimitri, 2026-09-28) ══════════════════════════════════════════
//
//   « Des écrans vides sans un mot, c'est moi qui prends une décision sur du
//     néant en croyant voir mes vraies données. »
//
// Le défaut n'était pas que la lecture échoue — c'est qu'elle échouait EN
// SILENCE : une page HTML servie en 200 (protection Vercel d'un aperçu, page
// d'erreur d'hébergeur, portail captif) était adoptée comme un blob vide, et
// le parc, le calendrier, l'argent, les fiches s'ouvraient vides sans un mot.
// La garde qui refuse vit dans `src/lib/reponse-json.js` ; CE fichier est la
// moitié qui compte autant : ce que Dimitri LIT.
//
// Motif maison, délibérément : même forme que `BandeauVersionPerimee` (sticky
// en tête du shell, charte DS, bouton « Recharger », rôle ARIA) — on ne crée
// pas un nouveau langage d'alerte à chaque panne.
//
// Deux différences assumées avec le bandeau de version :
//   • sémantique DANGER et non warning. Une version périmée est un décalage
//     qui attend ; un écran qui ment sur les données en cours est une erreur.
//   • AUCUN « × » pour fermer. Le bandeau de version se reporte de 30 min
//     parce que l'app reste juste en attendant. Ici, tant que la lecture n'a
//     pas abouti, l'écran affiche un vide qui n'est pas la réalité : pouvoir
//     masquer l'avertissement, c'est reconstituer exactement l'incident. La
//     seule sortie est de recharger.

import { DS } from "../lib/ui";

// F13 suite, point 7 — SUR TÉLÉPHONE, le bandeau (collé en haut, z-index 1001)
// passait AU-DESSUS des fenêtres (999 / 1000) et cachait leur croix de
// fermeture sur 375 px. Sous 860 px (le seuil « mobile » de l'appli), il passe
// SOUS les fenêtres : 40, au-dessus de la barre du haut (30), sous la plus
// basse des fenêtres (50). Fenêtre fermée, il est de nouveau en tête.
// Ordinateur : inchangé.
const REGLE_TELEPHONE =
  "@media (max-width:860px){.fbz-bandeau-lecture{z-index:40 !important}}";

export default function BandeauLectureIllisible({ messages }) {
  const liste = (messages || []).filter(Boolean);
  if (liste.length === 0) return null;

  // La règle vit HORS de l'alerte : son texte n'entre pas dans ce qui est lu.
  return (
    <>
      <style>{REGLE_TELEPHONE}</style>
      <div
        role="alert"
        data-testid="app-lecture-illisible"
        className="fbz-bandeau-lecture"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1001,
          background: DS.dangerBg,
          borderBottom: `2px solid ${DS.danger}`,
          padding: "12px 18px",
          display: "flex",
          alignItems: "center",
          gap: 14,
          fontFamily: DS.fontBody,
          boxShadow: "0 2px 8px rgba(0,0,0,.08)",
        }}
      >
        <span style={{ fontSize: 20 }} aria-hidden="true">
          ⚠️
        </span>
        <div
          style={{
            flex: 1,
            fontSize: 13,
            color: DS.dangerText,
            lineHeight: 1.45,
          }}
        >
          {liste.map((m) => (
            <div key={m} style={{ marginBottom: liste.length > 1 ? 4 : 0 }}>
              {m}
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            background: DS.dangerText,
            color: DS.white,
            border: "none",
            borderRadius: DS.radiusControl,
            padding: "7px 14px",
            fontWeight: 700,
            fontSize: 12,
            cursor: "pointer",
            fontFamily: DS.fontBody,
            whiteSpace: "nowrap",
          }}
        >
          Recharger la page
        </button>
      </div>
    </>
  );
}
